import * as yup from 'yup'

import { LISTBANCAIRE } from 'components/listCartebancairepays'

const COUNTRY_MAP: Record<string, string> = {
  '216': 'TUN',
  '221': 'SEN',
  '212': 'MAR',
  '92': 'PAK',
  '880': 'BDT',
  '90': 'TUR',
  '234': 'NGA',
  '254': 'KEN',
  '63': 'PHL',
}

export const getSelectedPrefix = (phonePrefix: string) => {
  const countryCode = COUNTRY_MAP[phonePrefix]

  return countryCode
    ? LISTBANCAIRE[countryCode]
    : undefined
}
export const createBeneficiaryValidationSchema = () => {


    
  return yup
    .object({
      firstName: yup
        .string()
        .required('Ce champ est requis')
        .min(2, 'Nom non valide')
        .matches(
          /^[a-zA-ZÀ-ÿ\u00C0-\u017F\s'’œŒæÆçÇ-]+$/,
          'Le nom doit contenir uniquement des lettres'
        ),

      lastName: yup
        .string()
        .required('Ce champ est requis')
        .min(2, 'Nom non valide')
        .matches(
          /^[a-zA-ZÀ-ÿ\u00C0-\u017F\s'’œŒæÆçÇ-]+$/,
          'Le nom doit contenir uniquement des lettres'
        ),

      gender: yup
        .string()
        .required('Ce champ est requis'),

      relationship: yup
        .string()
        .required('Ce champ est requis'),

      phonePrefix: yup
        .string()
        .required('Ce champ est requis'),

      phoneNumber: yup
        .string()
        .required('Ce champ est requis')
        .matches(
          /^\d+$/,
          'Le numéro doit contenir uniquement des chiffres'
        )
        .when('phonePrefix', ([phonePrefix], schema) => {
          const selectedPrefix = getSelectedPrefix(phonePrefix)

          const phoneLength =
            selectedPrefix?.lengthPhone ?? 8

          return schema.length(
            phoneLength,
            `Le numéro de téléphone doit contenir ${phoneLength} chiffres.`
          )
        }),

      beneficiaryIdentifiant: yup
        .string()
        .when('phonePrefix', ([phonePrefix], schema) => {
          if (phonePrefix === '216') {
            return schema.notRequired()
          }

          const selectedPrefix =
            getSelectedPrefix(phonePrefix)

          return schema.length(
            selectedPrefix?.LengthCIN ?? 8,
            `Le numéro doit contenir ${
              selectedPrefix?.LengthCIN ?? 8
            } chiffres.`
          )
        }),

      Iban: yup.string(),

      confirmerNumeroCompte: yup.string(),

      bankName: yup.string(),

      CodeIBAN: yup.string(),

      SWIFTBIC: yup.string(),

      bankCode: yup.string(),

      avatar: yup.number(),
    })
    .test(
      'validate-bank-information',
      'Informations bancaires invalides',
      function (values) {
        const cin =
          values.beneficiaryIdentifiant?.trim() || ''

        const Iban =
          values.Iban?.trim() || ''

        const confirmerNumeroCompte =
          values.confirmerNumeroCompte?.trim() || ''

        const bankName = values.bankName

        const isTunisia =
          values.phonePrefix === '216'

        const isMaroc =
          values.phonePrefix === '212'

        const isBankSelected =
          values.phonePrefix === '90' ||
          values.phonePrefix === '63'

        // CAS 1 : tout est vide
        if (
          !cin &&
          !Iban &&
          !confirmerNumeroCompte &&
          !bankName
        ) {
          return true
        }

        // CAS 2 : au moins une information bancaire est remplie

        if (!bankName && isBankSelected) {
          return this.createError({
            path: 'bankName',
            message: 'Ce champ est requis',
          })
        }

        if (!cin && !isTunisia) {
          return this.createError({
            path: 'beneficiaryIdentifiant',
            message: 'Ce champ est requis',
          })
        }

        if (!Iban) {
          return this.createError({
            path: 'Iban',
            message: 'Ce champ est requis',
          })
        }

        if (!confirmerNumeroCompte) {
          return this.createError({
            path: 'confirmerNumeroCompte',
            message: 'Ce champ est requis',
          })
        }

        // Vérification CIN

        const verifCIN = isMaroc
          ? /^[A-Z 0-9]{5,10}$/
          : /^\d+$/

        if (!isTunisia && !verifCIN.test(cin)) {
          return this.createError({
            path: 'beneficiaryIdentifiant',
            message: isMaroc
              ? 'Format CIN Maroc invalide'
              : 'Le numéro doit contenir uniquement des chiffres',
          })
        }

        // Vérification RIB / IBAN

        if (!/^\d+$/.test(Iban)) {
          return this.createError({
            path: 'Iban',
            message:
              'Le numéro doit contenir uniquement des chiffres',
          })
        }

        const detailsBank =
          getSelectedPrefix(values.phonePrefix)

        const lengthRIB =
          detailsBank?.LengthRIB

        const lengthCodeIBAN =
          detailsBank?.lengthCodeIBAN ?? 0

        const bankCode =
          Iban.substring(0, lengthCodeIBAN)

        const fieldName =
          values.phonePrefix === '90' ||
          values.phonePrefix === '63'
            ? 'IBAN'
            : 'RIB'

        const isValidBank =
          detailsBank?.banks?.some(
            bank => bank.code === bankCode
          ) ?? false

        if (
          !isValidBank &&
          values.phonePrefix !== '90' &&
          values.phonePrefix !== '63'
        ) {
          return this.createError({
            path: 'Iban',
            message: `Le ${fieldName} n'est pas correct.`,
          })
        }

        // Vérification longueur RIB

        if (typeof lengthRIB === 'number') {
          if (Iban.length !== lengthRIB) {
            return this.createError({
              path: 'Iban',
              message: `Le numéro doit contenir ${lengthRIB} chiffres.`,
            })
          }
        }

        if (
          lengthRIB &&
          typeof lengthRIB !== 'number'
        ) {
          if (Iban.length < lengthRIB.min) {
            return this.createError({
              path: 'Iban',
              message: `Le numéro doit contenir au minimum ${lengthRIB.min} chiffres.`,
            })
          }

          if (Iban.length > lengthRIB.max) {
            return this.createError({
              path: 'Iban',
              message: `Le numéro doit contenir au maximum ${lengthRIB.max} chiffres.`,
            })
          }
        }

        // Vérification confirmation

        if (Iban !== confirmerNumeroCompte) {
          return this.createError({
            path: 'confirmerNumeroCompte',
            message: `Les numéros ${fieldName} doivent correspondre.`,
          })
        }

        return true
      }
    )
}